// libraries
import React from 'react'

export function SvgBottomSeparator({ className }: { className?: string }) {
    return (
        <svg className={className} preserveAspectRatio='none' width='1440' height='14' viewBox='0 0 1440 14' xmlns='http://www.w3.org/2000/svg'><path d='M193.433 0.0033792C184.71 0.218849 -3.33923e-10 11.0034 -3.33923e-10 11.0034L8.29791e-06 13.5486L1440 13.5486L1440 11.0034L1128.61 0.00337917C1128.61 0.00337917 801.88 12.1236 593.568 10.7189C436.577 9.6603 202.155 -0.212091 193.433 0.0033792Z'/></svg>
    )
}